import { Typography } from "@mui/material";

import NothingToRead from "../../../../ui library/icons/NothingToRead";
import { STRINGS } from "../../utils/strings";

export default function NothingSelectedContainer() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-8">
      <NothingToRead />
      <div className="flex flex-col gap-1">
        <Typography className="text-center text-xl text-blue-700">
          <span className="font-semibold">{STRINGS.NOTHING_TO_READ}</span>
        </Typography>
        <Typography className="text-center">{STRINGS.NO_SELECTION}</Typography>
      </div>
    </div>
  );
}
